import {SortSubsidiaryCategoryModel} from '../Model'
import {SubsidiaryCategoryModel} from '../Model/SubsidiaryCategoryModel'

export const actionTypes = {
  // get
  GET_ALL_SUBSIDIARY_CATEGORY_START: 'GET_ALL_SUBSIDIARY_CATEGORY_START',
  GET_ALL_SUBSIDIARY_CATEGORY_SUCCESS: 'GET_ALL_SUBSIDIARY_CATEGORY_SUCCESS',
  GET_ALL_SUBSIDIARY_CATEGORY_FINISH: 'GET_ALL_SUBSIDIARY_CATEGORY_FINISH',

  // extended hours
  GET_SUBSIDIARY_CATEGORY_START: 'GET_SUBSIDIARY_CATEGORY_START',
  GET_SUBSIDIARY_CATEGORY_SUCCESS: 'GET_SUBSIDIARY_CATEGORY_SUCCESS',
  GET_SUBSIDIARY_CATEGORY_FINISH: 'GET_SUBSIDIARY_CATEGORY_FINISH',

  // add branch
  ADD_SUBSIDIARY_CATEGORY_START: 'ADD_SUBSIDIARY_CATEGORY_START',
  ADD_SUBSIDIARY_CATEGORY_SUCCESS: 'ADD_SUBSIDIARY_CATEGORY_SUCCESS',
  ADD_SUBSIDIARY_CATEGORY_FINISH: 'ADD_SUBSIDIARY_CATEGORY_FINISH',
  RESET_SUBSIDIARY_CATEGORY: 'RESET_SUBSIDIARY_CATEGORY',

  // update SUBSIDIARY_CATEGORY
  UPDATE_SUBSIDIARY_CATEGORY_START: 'UPDATE_SUBSIDIARY_CATEGORY_START',
  UPDATE_SUBSIDIARY_CATEGORY_SUCCESS: 'UPDATE_SUBSIDIARY_CATEGORY_SUCCESS',
  UPDATE_SUBSIDIARY_CATEGORY_FINISH: 'UPDATE_SUBSIDIARY_CATEGORY_FINISH',

  // delete SUBSIDIARY_CATEGORY
  DELETE_SUBSIDIARY_CATEGORY_START: 'DELETE_SUBSIDIARY_CATEGORY_START',
  DELETE_SUBSIDIARY_CATEGORY_SUCCESS: 'DELETE_SUBSIDIARY_CATEGORY_SUCCESS',
  DELETE_SUBSIDIARY_CATEGORY_FINISH: 'DELETE_SUBSIDIARY_CATEGORY_FINISH',

  // Enable SUBSIDIARY_CATEGORY
  ENABLE_SUBSIDIARY_CATEGORY_REQUEST: 'ENABLE_SUBSIDIARY_CATEGORY_REQUEST',
  ENABLE_SUBSIDIARY_CATEGORY_SUCCESS: 'ENABLE_SUBSIDIARY_CATEGORY_SUCCESS',
  ENABLE_SUBSIDIARY_CATEGORY_FINISH: 'ENABLE_SUBSIDIARY_CATEGORY_FINISH',

  // Disable SUBSIDIARY_CATEGORY
  DISABLE_SUBSIDIARY_CATEGORY_REQUEST: 'DISABLE_SUBSIDIARY_CATEGORY_REQUEST',
  DISABLE_SUBSIDIARY_CATEGORY_SUCCESS: 'DISABLE_SUBSIDIARY_CATEGORY_SUCCESS',
  DISABLE_SUBSIDIARY_CATEGORY_FINISH: 'DISABLE_SUBSIDIARY_CATEGORY_FINISH',

  // Enable SUBSIDIARY_CATEGORY
  SINGLE_ENABLE_SUBSIDIARY_CATEGORY_REQUEST: 'SINGLE_ENABLE_SUBSIDIARY_CATEGORY_REQUEST',
  SINGLE_ENABLE_SUBSIDIARY_CATEGORY_SUCCESS: 'SINGLE_ENABLE_SUBSIDIARY_CATEGORY_SUCCESS',
  SINGLE_ENABLE_SUBSIDIARY_CATEGORY_FINISH: 'SINGLE_ENABLE_SUBSIDIARY_CATEGORY_FINISH',

  // Disable SUBSIDIARY_CATEGORY
  SINGLE_DISABLE_SUBSIDIARY_CATEGORY_REQUEST: 'SINGLE_DISABLE_SUBSIDIARY_CATEGORY_REQUEST',
  SINGLE_DISABLE_SUBSIDIARY_CATEGORY_SUCCESS: 'SINGLE_DISABLE_SUBSIDIARY_CATEGORY_SUCCESS',
  SINGLE_DISABLE_SUBSIDIARY_CATEGORY_FINISH: 'SINGLE_DISABLE_SUBSIDIARY_CATEGORY_FINISH',

  // sort
  SORT_SUBSIDIARY_CATEGORY_START: 'SORT_SUBSIDIARY_CATEGORY_START',
  SORT_SUBSIDIARY_CATEGORY_SUCCESS: 'SORT_SUBSIDIARY_CATEGORY_SUCCESS',
  SORT_SUBSIDIARY_CATEGORY_FINISH: 'SORT_SUBSIDIARY_CATEGORY_FINISH',
  SORT_SUBSIDIARY_CATEGORY_RESET: 'SORT_SUBSIDIARY_CATEGORY_RESET',
}
